import React, { useState, useRef } from 'react';
import { HDate } from '@hebcal/core';
import Picker from 'react-mobile-picker';
import { useDrag } from '@use-gesture/react';
import { HebDateUtil } from '../Util/HebDateUtil';

const DAY_TITLES = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ז', 'ח', 'ט', 'י', 'יא', 'יב', 'יג', 'יד', 'טו',
  'טז', 'יז', 'יח', 'יט', 'כ', 'כא', 'כב', 'כג', 'כד', 'כה', 'כו', 'כז', 'כח', 'כט', 'ל'];

const MONTHS_LEAP = [
  { value: 'TISHREI', title: 'תשרי' }, { value: 'CHESHVAN', title: 'חשון' }, { value: 'KISLEV', title: 'כסלו' },
  { value: 'TEVET', title: 'טבת' }, { value: 'SHVAT', title: 'שבט' }, { value: 'ADAR_I', title: 'אדר א' },
  { value: 'ADAR_II', title: 'אדר ב' }, { value: 'NISAN', title: 'ניסן' }, { value: 'IYYAR', title: 'אייר' },
  { value: 'SIVAN', title: 'סיון' }, { value: 'TAMUZ', title: 'תמוז' }, { value: 'AV', title: 'אב' },
  { value: 'ELUL', title: 'אלול' },
];
const MONTHS_REGULAR = MONTHS_LEAP
  .filter(m => m.value !== 'ADAR_II')
  .map(m => m.value === 'ADAR_I' ? { value: 'ADAR_I', title: 'אדר' } : m);

const YEARS = [];
for (let y = 5600; y <= new HDate().yy; y++)
  YEARS.push(y);

const SettingsDate = ({ date, setDate, delDate, moveDate }) => {
  const [stateOpen, setStateOpen] = useState(false);
  const [stateDragY, setStateDragY] = useState(0);
  const rowRef = useRef(null);

  const bindDrag = useDrag(({ down, movement: [, my], last }) => {
    setStateDragY(down ? my : 0);
    if (last) {
      const offset = Math.round(my / rowRef.current.offsetHeight);
      if (offset !== 0) moveDate(offset);
    }
  }, { axis: 'y', filterTaps: true });

  const isLeap = new HDate(1, 'TISHREI', date.y).isLeapYear();
  const months = isLeap ? MONTHS_LEAP : MONTHS_REGULAR;
  const daysInMonth = new HDate(1, date.m, date.y).daysInMonth();

  const pickerValue = { d: String(date.d), m: date.m, y: String(date.y) };
  const dateText = `${DAY_TITLES[date.d - 1]} ${(months.find(m => m.value === date.m) || {}).title} ${HebDateUtil.Gimatria(date.y)}`;

  const handleChange = (value) => {
    const y = parseInt(value.y);
    let m = value.m;
    if (m === 'ADAR_II' && !new HDate(1, 'TISHREI', y).isLeapYear())
      m = 'ADAR_I';
    let d = parseInt(value.d);
    const dim = new HDate(1, m, y).daysInMonth();
    if (d > dim) d = dim;
    setDate({ ...date, y, m, d });
  };

  const renderItem = (title) => ({ selected }) =>
    <span className={ selected ? 'HebWheelSelected' : 'HebWheelItem' }>{ title }</span>;

  return (
    <div className='BirthdayRow' ref={ rowRef } style={ stateDragY !== 0 ? { transform:`translateY(${stateDragY}px)`, position:'relative', zIndex:10, backgroundColor:'#f7f1e3' } : undefined }>
      <span className='BirthdayDrag' { ...bindDrag() }>&#8801;</span>
      <input type='text' className='BirthdayName' placeholder='שם' value={ date.name || '' } onChange={ (event) => setDate({ ...date, name: event.target.value }) } />
      <input type='text' className='BirthdayDateField' readOnly value={ dateText } onClick={ () => setStateOpen(true) } />
      <button onClick={ delDate }>מחק</button>
      { stateOpen &&
        <div className='HebWheelOverlay' onClick={ () => setStateOpen(false) }>
          <div className='HebWheelPopup' onClick={ (event) => event.stopPropagation() }>
            <div className='HebWheelWrap'>
              <Picker value={ pickerValue } onChange={ handleChange } height={ 160 } itemHeight={ 32 } wheelMode='natural'>
                <Picker.Column name='d'>
                  { DAY_TITLES.slice(0, daysInMonth).map((title, i) =>
                      <Picker.Item key={ i + 1 } value={ String(i + 1) }>{ renderItem(title) }</Picker.Item>) }
                </Picker.Column>
                <Picker.Column name='m'>
                  { months.map(m =>
                      <Picker.Item key={ m.value } value={ m.value }>{ renderItem(m.title) }</Picker.Item>) }
                </Picker.Column>
                <Picker.Column name='y'>
                  { YEARS.map(y =>
                      <Picker.Item key={ y } value={ String(y) }>{ renderItem(HebDateUtil.Gimatria(y)) }</Picker.Item>) }
                </Picker.Column>
              </Picker>
            </div>
            <button className='HebWheelOk' onClick={ () => setStateOpen(false) }>אישור</button>
          </div>
        </div>
      }
    </div>
  );
}

export default SettingsDate;
